import React from "react";
import { StaticImage } from "gatsby-plugin-image";

const TERi =()=>{
    return(
        <div className="fixed bottom-5 right-5 z-50 " >
            <div className="bg-telecel_white border border-border_lighter shadow-xl w-18 h-18 md:w-20 md:h-20 rounded-full cursor-pointer pulse" >
                <a href="https://chat.vodafone.com.gh/" className="" >
                    <StaticImage
                        src="../../../images/teri_default.png"
                        className={`w-full h-full rounded-full`}
                        alt="tobi"
                        placeholder="blurred"
                        />
                </a>

            </div>
        </div>
    )
}

export default TERi 

